import {
  WIRCreateJourneyStepsKeys,
  WIRStageGate5SectionKey,
  WIRStageGate5Sections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { WIR, WIRActionStatus } from 'types/wellGuardian';

export const getWirStageGate5Sections = (wir: WIR | null) =>
  (wir &&
    Object.keys(WIRStageGate5Sections)
      .map(item => ({
        label: WIRStageGate5Sections[item as WIRStageGate5SectionKey],
        value: item,
        phase: WIRCreateJourneyStepsKeys.STAGE_GATE_5,
      }))
      .filter(stepItem => {
        // First check static exclusions
        if (
          stepItem.label === WIRStageGate5Sections.interventionSingleSlideSummary ||
          stepItem.label === WIRStageGate5Sections.wonsCloseOut ||
          stepItem.label === WIRStageGate5Sections.completionSchematicUpdate ||
          stepItem.label === WIRStageGate5Sections.wellSchematicUpdate ||
          stepItem.label === WIRStageGate5Sections.interventionWellDataStored ||
          stepItem.label === WIRStageGate5Sections.vendorCloseOut ||
          stepItem.label === WIRStageGate5Sections.assetCloseOutPresentation ||
          stepItem.label === WIRStageGate5Sections.rex ||
          stepItem.label === WIRStageGate5Sections.costConsolidationCloseOut
        ) {
          return false;
        }

        // Then check for matching action with deleted state
        const matchingAction = wir?.actions?.find(item =>
          item.actionName?.includes(stepItem.label),
        );
        // If no matching action found, include the section
        // If matching action found, include only if it's NOT deleted
        return !matchingAction || matchingAction?.state !== WIRActionStatus.DELETED;
      })) ??
  [];
